/**
 * Duration of the fill animation in seconds.
 * Shared between ProgressBar's CSS transition and useFakeProgress's step gap.
 */
export const FILL_TRANSITION_DURATION = 0.4;
